import React, {FC, useEffect, useState} from 'react'
import {Modal, Button, Form, Spinner, InputGroup} from 'react-bootstrap'

interface ModalAddSourcesProps {
  show: boolean
  onHide: () => void
  onSubmit: () => void
  alias: string
  link: string
  onAliasChange: (value: string) => void
  onLinkChange: (value: string) => void
  isLoading?: boolean
  handleVerifySourceUrl: (url: string) => void
  isSourceLinkVerified: boolean | null
}

const ModalAddSources: FC<ModalAddSourcesProps> = ({
  show,
  onHide,
  onSubmit,
  alias,
  link,
  onAliasChange,
  onLinkChange,
  isLoading = false,
  handleVerifySourceUrl,
  isSourceLinkVerified,
}) => {
  const [isLoadingVerify, setIsLoadingVerify] = useState(false)
  const validateRequiredFields = () => {
    if (link && link.trim().length > 0) {
      return isSourceLinkVerified !== null
    }
    return true
  }

  useEffect(() => {
    validateRequiredFields()
  }, [link, isSourceLinkVerified])

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Source</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className='mb-3'>
          <Form.Label>Alias</Form.Label>
          <Form.Control
            value={alias}
            placeholder='e.g. EN, WTO, WIPO'
            onChange={(e) => onAliasChange(e.target.value)}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Link</Form.Label>
          {isSourceLinkVerified !== null && (
            <div className='mb-2'>
              <Form.Text className={isSourceLinkVerified ? 'text-success' : 'text-danger'}>
                {isSourceLinkVerified ? 'Valid URL' : 'Invalid URL'}
              </Form.Text>
            </div>
          )}
          <InputGroup hasValidation>
            <Form.Control
              value={link}
              isInvalid={link.length > 0 && !/^https?:\/\//.test(link)}
              placeholder='https://example.com/file.xml'
              onChange={(e) => onLinkChange(e.target.value)}
            />
            <Button
              variant='outline-secondary'
              disabled={
                isLoadingVerify || !link || link.trim() === '' || !/^https?:\/\//.test(link)
              }
              onClick={async () => {
                setIsLoadingVerify(true)
                await handleVerifySourceUrl(link)
                setIsLoadingVerify(false)
              }}
            >
              {isLoadingVerify && <Spinner animation='border' size='sm' className='me-2' />}
              Verify
            </Button>
            <Form.Control.Feedback type='invalid'>
              URL must start with http:// or https://
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant='default' onClick={onHide}>
          Cancel
        </Button>

        <Button
          variant='primary'
          onClick={onSubmit}
          disabled={
            !alias.trim() ||
            !link.trim() ||
            isLoading ||
            !validateRequiredFields()
          }
        >
          {isLoading ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              Submitting...
            </>
          ) : (
            'Submit'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalAddSources
